import { render, staticRenderFns } from "./MessagesCard.vue?vue&type=template&id=2ae0ef95&"
import script from "./MessagesCard.vue?vue&type=script&lang=js&"
export * from "./MessagesCard.vue?vue&type=script&lang=js&"
import style0 from "./MessagesCard.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports